import React from "react"
import Components from "../index"
import { blokType } from "../../types"


import {
  StyledCardProfile,
  StyledProfileImage,
  StyledCardProfileText,
  StyledCardLinkWrapper,
  StyledCardLink,
} from "./partials"

export interface CardProfileProps {
  profile_image: any
  name: string
  title: string
  wrapper_link: blokType[];
}

export const CardProfileCmp: React.FC<CardProfileProps> = ({
  profile_image,
  name,
  title,
  wrapper_link,
}) => {
  return (
    <StyledCardProfile wrapper_link={wrapper_link && wrapper_link.length > 0}>
        {wrapper_link && (
          <StyledCardLinkWrapper>
            {wrapper_link.length > 0 && (
              <StyledCardLink>
                {wrapper_link.map((l) =>
                  React.createElement(Components(l.component), {
                    key: l._uid,
                    blok: l,
                  })
                )}
              </StyledCardLink>
            )}
          </StyledCardLinkWrapper>
        )}
      {profile_image && (
        <StyledProfileImage>
          <img src={profile_image.filename}></img>
        </StyledProfileImage>
      )}
      <StyledCardProfileText>
        {name && <p>{name}</p>}
        {title && <p>{title}</p>}
      </StyledCardProfileText>
    </StyledCardProfile>
  )
}
